import { render, staticRenderFns } from "./PdfTest.vue?vue&type=template&id=3927e22f&"
import script from "./PdfTest.vue?vue&type=script&lang=ts&"
export * from "./PdfTest.vue?vue&type=script&lang=ts&"
import style0 from "./PdfTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports